import { useMutation } from "react-query"
import api from "../client"

const deleteData = async (uuid: string | undefined) => {
  const { data } = await api.delete(
    `/address/used/${uuid}`,
  )
  return data
}

export const useDeleteUsedAddress = () => {
  return useMutation((uuid: string | undefined) => {
    return deleteData(uuid)
  })
}
